module.exports = __webpack_public_path__ + "static/media/image-6.b3d80654.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/SEOin2020/image-6.png
// module id = 468
// module chunks = 0